import { render } from "./ListaLinkReportePorNegocio.vue?vue&type=template&id=5fdbb74c"
import script from "./ListaLinkReportePorNegocio.vue?vue&type=script&lang=js"
export * from "./ListaLinkReportePorNegocio.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__